import { clsx } from '@payaca/utilities/cvaMerge';
import React, {
  ComponentPropsWithoutRef,
  FC,
  PropsWithChildren,
  useId,
} from 'react';
import Card from '../Card/Card';

type OwnInputProps = 'id' | 'type';

export interface IProps extends Omit<
  ComponentPropsWithoutRef<'input'>,
  OwnInputProps
> {
  multiple?: boolean;
  src?: string;
  label?: string;
}

const ImageGroupFieldInput = React.forwardRef<HTMLInputElement, IProps>(
  (props, ref) => {
    const {
      className,
      label,
      src,
      multiple = false,
      disabled,
      ...rest
    } = props;
    const uId = useId();

    return (
      <Card
        as="label"
        htmlFor={uId}
        sizeVariant="lg"
        className={clsx(
          'group overflow-hidden has-[:checked]:ring-2 has-[:checked]:ring-blue-600 min-h-40',
          disabled ? 'cursor-not-allowed' : 'cursor-pointer'
        )}
      >
        <input
          ref={ref}
          type={multiple ? 'checkbox' : 'radio'}
          className={clsx('hidden', className)}
          id={uId}
          disabled={disabled}
          {...rest}
        />
        <img src={src} />
        <span
          className={clsx(
            'mt-auto px-2 py-3 font-semibold',
            disabled ? '' : 'group-hover:bg-gray-50'
          )}
        >
          {label}
        </span>
      </Card>
    );
  }
);

ImageGroupFieldInput.displayName = 'ImageGroupFieldInput';

const ImageGroupField: FC<PropsWithChildren> = (props) => {
  const { children } = props;

  return (
    <div className="grid grid-cols-2 gap-2 sm:grid-cols-4 sm:gap-4">
      {children}
    </div>
  );
};

export default Object.assign(ImageGroupFieldInput, { Group: ImageGroupField });
